import React from 'react';
import { connectCurrentRefinements } from 'react-instantsearch-dom';

import './current-refinements.scss';

const Refinement = ({label, id, value, createURL, refine, currentRefinement}) => {
  if ( 'genre.lvl0' === id ) {
    label = currentRefinement;
    id = 'genre';
  }

  return (
    <li
      className={`filter-${id}`}
    >
      {label}
      <span
        className="delete"
        onClick={() => {
          refine(value);
        }}
      >
        x
      </span>
    </li>
  );
};

const currentRefinements = ({ items, refine, createURL }) => {
  return (
  <ul>
    {items.map(item => {
      return (
        <React.Fragment key={item.id}>
          {item.items ? (
            <React.Fragment>
              {item.items.map(nested => (
                <Refinement
                  key={nested.label}
                  id={item.id}
                  value={nested.value}
                  label={nested.label}
                  refine={refine}
                  createURL={createURL}
                />
              ))}
            </React.Fragment>
          ) : (
            <Refinement
              key={item.label}
              id={item.id}
              value={item.value}
              label={item.label}
              refine={refine}
              createURL={createURL}
              currentRefinement={item.currentRefinement}
            />
          )}
        </React.Fragment>
      )}
    )}
  </ul>
)};

const CurrentRefinements = connectCurrentRefinements(currentRefinements);

export default CurrentRefinements;